import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitLead(payload) {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
}

export async function uploadLeadFiles(leadId, files) {
  if (!files || files.length === 0) return { uploaded: 0 };
  const form = new FormData();
  files.forEach((f) => form.append("files", f));
  const { data } = await axios.post(`${API}/leads/${leadId}/attachments`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
